module.exports = __webpack_public_path__ + "static/media/alarm-2.28cbb130.svg";